import { render, staticRenderFns } from "./MeetingBottomBar.vue?vue&type=template&id=4347ff7a&scoped=true&"
import script from "./MeetingBottomBar.vue?vue&type=script&lang=js&"
export * from "./MeetingBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./MeetingBottomBar.vue?vue&type=style&index=0&id=4347ff7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4347ff7a",
  null
  
)

export default component.exports